export default {
    en: {
        msg: {
            name: 'Name',
            email: 'Email',
            message: 'Message',
            add_file: 'Add File',
            send: 'Send',
            select_domain: 'Select site',
            select_subject: 'Select Subject',
            subject: 'Subject',
            thanx: 'Thank you for your feedback'
        }
    },
    ru: {
        msg: {
            name: 'Ф.И.О.',
            email: 'E-mail',
            message: 'Сообщение',
            add_file: 'Прикрепить',
            send: 'Отправить',
            select_domain: 'Выберите сайт',
            select_subject: 'Выберите тему',
            subject: 'Тема',
            thanx: 'Благодарим за Ваш отзыв'
        }
    }
}



// WEBPACK FOOTER //
// ./src/lang-data.js